(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('MaturitySummaryReportController', MaturitySummaryReportController);

	MaturitySummaryReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function MaturitySummaryReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			types: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						var totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);

						// by maturity
						var winesGrouped = lodash.groupBy(self.wines, function(w) {
							return w.getMaturity();
						});

						self.report.tableHeaders = [
							'Maturity (Total ' + Object.keys(winesGrouped).length + ')',
							'Wines',
							'% Wines in Cellar',
							'Bottles',
							'% Bottles in Cellar',
							'Producers',
							'Varietals',
							'Countries',
							'Red',
							'White',
							'Sparkling',
							'Dessert',
							'Fortified',
							'Rose',
							'Other Types'
						];

						// initialize totals
						var totals = {
							wines:  0,
							bottles: 0,
							inStockValue: 0,
							purchaseValue: 0,
							bottlesOut: 0
						};

						var maturitiesOrder = [
							'Early',
							'Young',
							'Mature',
							'Old',
							'Late',
							'Uncertain'
						];

						var winesGroupedOrdered = {};

						// order by maturitiesOrder
						lodash.forEach(maturitiesOrder, function(maturityName) {
							winesGroupedOrdered[maturityName] = winesGrouped[maturityName];
						});

						var categoryGrandTotals = {
							red: 0,
							white: 0,
							sparkling: 0,
							dessert: 0,
							fortified: 0,
							rose: 0,
							other: 0
						};

						lodash.forEach(winesGroupedOrdered, function(wines, producer) {
							// get total by category
							var groupedCategoryName = lodash.groupBy(wines, function(wine) {
								return (wine.category && wine.category.name) ? wine.category.name.toLowerCase() : 'other';
							});

							var categoryTotal = {};
							categoryTotal.red = (groupedCategoryName['red']) ? groupedCategoryName['red'].length : '0';
							categoryTotal.white = (groupedCategoryName['white']) ? groupedCategoryName['white'].length : '0';
							categoryTotal.sparkling = (groupedCategoryName['sparkling']) ? groupedCategoryName['sparkling'].length : '0';
							categoryTotal.dessert = (groupedCategoryName['dessert']) ? groupedCategoryName['dessert'].length : '0';
							categoryTotal.fortified = (groupedCategoryName['fortified (non-dessert)']) ? groupedCategoryName['fortified (non-dessert)'].length : '0';
							categoryTotal.rose = (groupedCategoryName['rose']) ? groupedCategoryName['rose'].length : '0';
							categoryTotal.other = (groupedCategoryName['other']) ? groupedCategoryName['other'].length : '0';

							lodash.forEach(categoryGrandTotals, function(val, key) {
								categoryGrandTotals[key] += parseInt(categoryTotal[key]);
							});

							var totalWinesInGroup = (wines) ? wines.length : 0;

							// add wines to grand total
							totals.wines += totalWinesInGroup;

							// count bottles, start at 0
							var totalBottlesInGroup = lodash.reduce(wines, function(total, wine) {
								return total + lodash.parseInt(wine.cellar.qty);
							}, 0);
							// add bottles to grand total
							totals.bottles += totalBottlesInGroup;

							var producers = lodash.unique(lodash.pluck(wines, 'producer.name'));
							var varietals = lodash.unique(lodash.pluck(wines, 'varietal.name'));
							var countries = lodash.unique(lodash.pluck(wines, 'region.country'));

							var tableSummary = [
								// "Producer":
								(producer) ? producer : 'Unknown',
								// "Wines":
								totalWinesInGroup,
								// "% Wines in Cellar":
								$window.numeral(totalWinesInGroup / totalWines).format('0.00%'),
								// "Bottles":
								totalBottlesInGroup,
								// "% Bottles in Cellar":
								$window.numeral(totalBottlesInGroup / totalBottles).format('0.00%'),
								// Producers
								producers.length,
								// Varietals
								varietals.length,
								// Countries
								countries.length,
								// Red
								categoryTotal.red,
								// White
								categoryTotal.white,
								// Sparkling
								categoryTotal.sparkling,
								// Dessert
								categoryTotal.dessert,
								// Fortified
								categoryTotal.fortified,
								// Rose
								categoryTotal.rose,
								// Other Types
								categoryTotal.other
							];

							self.report.types.push({ summary: tableSummary });

						});

						self.report.totals = [
							// 'Maturity (Total ' + Object.keys(winesGrouped).length + ')',
							'Totals',
							// 'Wines',
							totals.wines,
							// '% Wines in Cellar',
							null,
							// 'Bottles',
							totalBottles,
							// '% Bottles in Cellar',
							null,
							// 'Producers',
							null,
							// 'Varietals',
							null,
							// 'Countries',
							null,
							// Category Totals
							categoryGrandTotals.red,
							categoryGrandTotals.white,
							categoryGrandTotals.sparkling,
							categoryGrandTotals.dessert,
							categoryGrandTotals.fortified,
							categoryGrandTotals.rose,
							categoryGrandTotals.other
						];

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function print(){
			return $window.print();
		}
	}

})();
